import { createSelector } from 'reselect';
import {
  HIDE_ORDER_TYPE_POPUP,
  LOCATION_DETAILS,
  UPDATE_LOCATION_DETAILS,
  MODE_OF_ORDER,
  DELIVERY_PLACE_CHANGE,
  ADD_TO_BAG,
  ADD_TO_BAG_CACHE,
  REMOVE_ITEM,
  DELIVERY_DETAILS,
  MERCHANT_DETAILS,
  GO_TO_CHECKOUT,
  ORDER_DATE,
  ORDER_TIME,
  UPDATE_TIP_PRICE,
  SHOW_MOBILE_SIDEBAR,
  MERCHANT_DATA_NAME,
  UPDATE_ORDER_ID_DATA,
  LOCATION_CHANGED,
  ROUTE,
  RESET_DASHBOARD,
  CHECKOUT_DINING_CHANGED,
  RESET_CHECKOUT_DINING_CHANGED,
  SET_ORDER_TYPE_POPUP_ON_ADD_TO_CART,
  UNSET_ORDER_TYPE_POPUP_ON_ADD_TO_CART,
  REFER_LAVUTOGO_DATANAME,
  LIST_OF_RESTAURANT,
  REFRESH_TAX_DETAILS,
  RESTORE_TAX_DETAILS,
  SET_ORDER_TIME_VALIDATION_STATE,
  RELOAD_STORE,
  UPDATE_CART,
  RESET_POST_CHECKOUT,
  PAYMENT_MODE,
  SET_USER_LOCATION,
  SET_USER__SELECTEDLOCATION,
  ADD_TO_TEMP_CART,
  UPDATING_TAX,
  REORDER_ITEMS,
  REORDER_TEMPCART_ITEMS,
  REORDER_REDIRECTION,
  SHOW_ORDER_PANEL,
} from './actions';
import { get } from 'lodash';
import { formattedAddress } from '../../lib/helper';
import { TYPE_DELIVERY } from '../../util/Constants';

const initialState = {
  isOrderTimeValid: true,
  showOrderTypePopup: false,
  deliverAddressPopup: false,
  orderTypePopupOnAddToCart: false,
  locationDetails: {},
  modeOfOrder: '',
  orderItemsList: [],
  showMobileOrder: true,
  numberOfItemsInCart: 0,
  cartPrice: 0,
  deliveryDetails: {},
  merchantDetails: {},
  itemTaxes: null,
  orderDate: '',
  orderTime: 0,
  tipPrice: 0,
  tipType: '',
  tipPercent: 0,
  showMobileSidebar: false,
  isReOrderRedirection: false,
  dataName: '',
  addingToCart: false,
  orderIdDetails: {
    order_id: '',
  },
  locationChanged: false,
  changedDataName: null,
  previousRoute: false,
  checkoutDiningChanged: false,
  refereLavuTogoDataName: true,
  referLavuTogoName: false,
  dataNameFilterForDining: false,
  listOfRestaurant: [],
  trashedTaxes: false,
  updatingTaxes: false,
  reloadStore: false,
  paymode: '',
  doNotEdit: false,
  hideDuplicateLavuToGoRestuarantList: false,
  previousModeOfOrder: 0,
  userLocation: false,
  tempCartItem: false,
  restaurantContactInformation: {},
  userSelectedLocation: '',
  isUserLocationSet: false,
  isReOrder: false,
  isReOrderRedirection: false,
  reOrderItemsData: [],
  reOrderStatPopUp: false,
};

const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ORDER_PANEL:
      return Object.assign({}, state, {
        showOrderPanel: action.show,
      });
    case ADD_TO_TEMP_CART:
      return Object.assign({}, state, {
        tempCartItem: action.payload,
        showOrderTypePopup: true,
      });

    case SET_USER_LOCATION:
      return Object.assign({}, state, {
        userLocation: action.payload,
      });

    case SET_USER__SELECTEDLOCATION:
      return Object.assign({}, state, {
        userSelectedLocation: action.payload,
      });

    case PAYMENT_MODE:
      return Object.assign({}, state, {
        paymode: action.mode,
      });

    case RESET_POST_CHECKOUT:
      return Object.assign({}, state, {
        orderTypePopupOnAddToCart: true,
        showOrderTypePopup: false,
        isReOrderRedirection: false,
        numberOfItemsInCart: 0,
        cartPrice: 0,
        itemTaxes: null,
        tipPrice: 0,
        tipType: '',
        orderItemsList: [],
        orderIdDetails: initialState.orderIdDetails,
        starttime: '',
        endtime: '',
        orderDate: '',
        orderTime: 0,
        modeOfOrder: '',
        showMobileSidebar: false,
      });

    case SET_ORDER_TIME_VALIDATION_STATE:
      return {
        ...state,
        isOrderTimeValid: action.payload,
      };
    case LIST_OF_RESTAURANT:
      return Object.assign({}, state, {
        listOfRestaurant: action.data,
      });

    case REFER_LAVUTOGO_DATANAME:
      let updateState = {
        refereLavuTogoDataName: action.refereName,
        referLavuTogoName: action.lavuTogoName,
        dataNameFilterForDining: true,
      };
      if (action.refereName !== false) {
        updateState['dataName'] = action.refereName;
      }
      if (action.reset === true) {
        updateState = Object.assign({}, updateState, {
          showOrderTypePopup: true,
          numberOfItemsInCart: 0,
          cartPrice: 0,
          itemTaxes: null,
          tipPrice: 0,
          tipType: '',
          orderTypePopupOnAddToCart: false,
          modeOfOrder: '',
          orderItemsList: [],
          orderIdDetails: initialState.orderIdDetails,
        });
      }
      return Object.assign({}, state, updateState);

    case UNSET_ORDER_TYPE_POPUP_ON_ADD_TO_CART:
      return Object.assign({}, state, {
        orderTypePopupOnAddToCart: false,
      });

    case SET_ORDER_TYPE_POPUP_ON_ADD_TO_CART:
      return Object.assign({}, state, {
        orderTypePopupOnAddToCart: true,
        showOrderTypePopup: false,
      });

    case RESET_DASHBOARD:
      return Object.assign({}, state, {
        numberOfItemsInCart: 0,
        cartPrice: 0,
        itemTaxes: null,
        tipPrice: 0,
        tipType: '',
        orderTypePopupOnAddToCart: false,
        modeOfOrder: action.restsetOrderType ? '' : state.modeOfOrder,
        orderItemsList: [],
        orderIdDetails: initialState.orderIdDetails,
      });

    case ROUTE:
      return Object.assign({}, state, {
        previousRoute: action.previousRoute,
      });
    case HIDE_ORDER_TYPE_POPUP:
      return Object.assign({}, state, {
        showOrderTypePopup: false,
      });
    case LOCATION_DETAILS:
      return Object.assign({}, state, {
        locationDetails: action.data,
        checkoutDiningChanged: false,
      });
    case UPDATE_LOCATION_DETAILS:
      const restaurantDetails = {
        ...action.data,
        selectedLocationAddressId: action.data.id,
        selectedLocationAddress: formattedAddress(action.data),
        restuarantName: action.data.title,
        distance: action.data.delivery_distance,
      };
      return {
        ...state,
        locationDetails: {
          ...state.locationDetails,
          ...restaurantDetails,
        },
      };

    case MODE_OF_ORDER:
      const orderModeInt = Number(action.data);
      const notDelivery = orderModeInt !== TYPE_DELIVERY;

      return Object.assign({}, state, {
        modeOfOrder: action.data,
        isUserLocationSet:
          notDelivery && orderModeInt !== 0
            ? true
            : state.isUserLocationSet !== true
              ? false
              : true,
        showOrderTypePopup: notDelivery ? false : state.showOrderTypePopup,
        orderTypePopupOnAddToCart: notDelivery
          ? false
          : state.orderTypePopupOnAddToCart,
      });

    case DELIVERY_PLACE_CHANGE:
      return Object.assign({}, state, {
        deliverAddressPopup: action.data,
      });
    case ADD_TO_BAG:
      localStorage.setItem(
        'dashboard',
        JSON.stringify(
          Object.assign({}, state, {
            orderItemsList: action.data,
            cartPrice: action.totalCartPrice,
            numberOfItemsInCart: action.updateCartCount
              ? action.numberOfItemsInCart
              : state.numberOfItemsInCart + action.numberOfItemsInCart,
            updatingTaxes: true,
            showOrderTypePopup: false,
            orderTypePopupOnAddToCart: false,
            tempCartItem: false,
          })
        )
      );
      return Object.assign({}, state, {
        orderItemsList: action.data,
        cartPrice: action.totalCartPrice,
        numberOfItemsInCart:
          state.numberOfItemsInCart + action.numberOfItemsInCart,
        updatingTaxes: true,
        showOrderTypePopup: false,
        orderTypePopupOnAddToCart: false,
        tempCartItem: false,
      });

    case ADD_TO_BAG_CACHE:
      const { data } = action;
      delete data.merchantDetails;
      delete data.listOfRestaurant;
      return Object.assign({}, state, data);

    case REMOVE_ITEM:
      if (action.clearOrderId) {
        state.orderIdDetails = initialState.orderIdDetails;
      }
      return Object.assign({}, state, {
        orderItemsList: action.data,
        cartPrice: action.totalCartPrice,
        numberOfItemsInCart: action.numberOfItemsInCart,
        updatingTaxes: !action.emptyCart,
        trashedTaxes: false,
      });

    case GO_TO_CHECKOUT:
      return Object.assign({}, state, {
        itemTaxes: state.doNotEdit === true ? state.itemTaxes : action.data,
        updatingTaxes: false,
        doNotEdit: false,
      });

    case DELIVERY_DETAILS:
      return Object.assign({}, state, {
        deliveryDetails: action.data,
        checkoutDiningChanged: false,
        orderTypePopupOnAddToCart: false,
        showOrderTypePopup: false,
      });

    case MERCHANT_DETAILS:
      return {
        ...state,
        merchantDetails: {
          ...action.data,
        },
      };

    case MERCHANT_DATA_NAME:
      window.dataName = action.data;
      return Object.assign({}, state, {
        dataName: action.data,
        restaurantContactInformation: action.restaurantContactInformation,
      });

    case REORDER_ITEMS:
      return Object.assign({}, state, {
        orderItemsList: action.data,
        itemTaxes: action.taxDetails,
        updatingTaxes: false,
        doNotEdit: false,
        isReOrder: true,
        isReOrderRedirection: true,
        orderTypePopupOnAddToCart: false,
        isDataNameFilterForDining: true,
        reOrderItemsData: action.reOrderItemsData,
      });
    case REORDER_REDIRECTION:
      return Object.assign({}, state, {
        isReOrderRedirection: action.payload,
        reOrderStatPopUp: false,
      });
    case REORDER_TEMPCART_ITEMS:
      return Object.assign({}, state, {
        showOrderTypePopup: true,
        orderTypePopupOnAddToCart: false,
        reOrderStatPopUp: true,
      });
    case ORDER_DATE:
      return {
        ...state,
        orderDate: action.orderDate,
        orderTime: action.orderTime,
      };

    case ORDER_TIME:
      return Object.assign({}, state, {
        orderTime: action.orderTime,
      });

    case UPDATE_TIP_PRICE:
      return Object.assign({}, state, {
        tipPrice: action.tipPrice,
        tipType: action.tipType,
        tipPercent: action.tipPercent,
      });

    case SHOW_MOBILE_SIDEBAR:
      return Object.assign({}, state, {
        showMobileSidebar:
          action.status === false ? false : !state.showMobileSidebar,
      });

    case UPDATE_ORDER_ID_DATA:
      return Object.assign({}, state, {
        orderIdDetails: action.orderIdDetails,
      });

    case LOCATION_CHANGED:
      return Object.assign({}, state, {
        locationChanged: action.data.status,
        changedDataName: action.data.changedDataName,
        reload: action.data.reload || 0,
        refereLavuTogoDataName: false,
        hideDuplicateLavuToGoRestuarantList: true,
        isUserLocationSet: action.data.resetUserLocation
          ? false
          : state.isUserLocationSet,
        deliverAddressPopup: action.data.resetUserLocation
          ? false
          : state.deliverAddressPopup,
        userLocation: action.data.resetUserLocation ? {} : state.userLocation,
        modeOfOrder: action.data.resetUserLocation
          ? ''
          : state.modeOfOrder || '',
      });

    case CHECKOUT_DINING_CHANGED:
      return Object.assign({}, state, {
        checkoutDiningChanged: true,
        previousModeOfOrder: state.modeOfOrder,
      });

    case RESET_CHECKOUT_DINING_CHANGED:
      return Object.assign({}, state, {
        checkoutDiningChanged: false,
      });

    case REFRESH_TAX_DETAILS:
      if (state.itemTaxes === null || !state.itemTaxes) {
        state.itemTaxes = {};
      }

      if (state.trashedTaxes === false && state.itemTaxes.taxdetails) {
        state.trashedTaxes = state.itemTaxes.taxdetails;
      }
      if (action.doNotEdit === true) {
        state.doNotEdit = true;
      }
      state.itemTaxes['taxdetails'] = action.data;
      return Object.assign({}, state, {});

    case RESTORE_TAX_DETAILS:
      if (state.itemTaxes === null || !state.itemTaxes) {
        state.itemTaxes = {};
      }

      if (state.trashedTaxes !== false && state.itemTaxes) {
        state.itemTaxes['taxdetails'] = state.trashedTaxes;
        state.trashedTaxes = false;
      }

      return state;

    case RELOAD_STORE:
      return Object.assign({}, state, {
        reloadStore: action.payload,
        checkoutDiningChanged: false,
      });

    case UPDATE_CART:
      return Object.assign({}, state, {
        orderItemsList: action.payload,
      });

    case UPDATING_TAX:
      return Object.assign({}, state, {
        updatingTaxes: action.status,
      });
    default:
      state.updatingTaxes = false;
      return state;
  }
};

/* Selectors */
export const dashboardData = state => state.dashboard;
export const getDashboardData = state => state.dashboard;
export const getDataName = state => get(state, 'dashboard.dataName', '');
export const getOrderTypePopUp = state =>
  get(state, 'dashboard.deliverAddressPopup', false);

export const getOrderDate = state => state.dashboard.orderDate;
export const getOrderTime = state => state.dashboard.orderTime;
export const getOrderTimeIsValidState = state =>
  get(state, 'dashboard.isOrderTimeValid', null);
export const getCartItems = state => get(state, 'dashboard.orderItemsList', []);
export const getOrderId = state =>
  get(state, 'dashboard.orderIdDetails.order_id', '');
export const getModeOfOrder = state => get(state, 'dashboard.modeOfOrder', '');
export const getDeliveryFee = state =>
  get(state, 'dashboard.locationDetails.delivery_fees', 0);

export const getOrderDetails = createSelector(
  [
    getOrderDate,
    getOrderTime,
    getOrderTimeIsValidState,
    getCartItems,
    getOrderId,
    getModeOfOrder,
    getDeliveryFee,
  ],
  (
    orderDate,
    orderTime,
    isOrderTimeValid,
    items,
    orderId,
    modeOfOrder,
    deliveryFee
  ) => ({
    orderDate,
    orderTime,
    isOrderTimeValid,
    items,
    orderId,
    modeOfOrder,
    deliveryFee,
  })
);

export const isOrderTypeOnCart = state =>
  get(state, 'dashboard.orderTypePopupOnAddToCart', false);

export const getRestaurantName = state =>
  get(state, 'dashboard.merchantDetails.title', '');
export const getRestaurantHours = state =>
  JSON.parse(
    get(state, 'dashboard.merchantDetails.ltg_start_end_time', null)
  ) || {};
export const getRestaurantMaxAdvanceNoticeDays = state =>
  get(state, 'dashboard.merchantDetails.max_advance_days', null);
export const getRestaurantMinAdvanceNoticeTime = state =>
  get(state, 'dashboard.merchantDetails.minimum_notice_time', null);
export const getDecimalSeparator = state =>
  get(state, 'dashboard.merchantDetails.decimal_separator', null);
export const getDecimalPoints = state =>
  get(state, 'dashboard.merchantDetails.disable_decimal', null);
export const getDiningOptions = state =>{
  let ltg_dine_in_option = get(state, 'dashboard.merchantDetails.ltg_dine_in_option', '');
  return ltg_dine_in_option ? ltg_dine_in_option.split(',') : [];
}
export const isTipEnabled = state => {
  return !!+get(state, 'dashboard.merchantDetails.ltg_tip', false);
};

export const getBraintreeSandBoxToken = state =>
  get(state, 'dashboard.merchantDetails.ltg_payment_info.paypal.paypal_token');
export const isPayPalEnabled = state => {
  return (
    Number(
      get(
        state,
        'dashboard.merchantDetails.ltg_payment_info.paypal.paypal_status',
        0
      )
    ) === 1
  );
};
export const isOnCheckOutDisplayRestaurantInfo = state => {
  let status = get(
    state,
    'dashboard.merchantDetails.ltg_on_checkout_display_restaurant_info',
    '1'
  );
  return status === '1' ? true : false;
};

export const getRestaurantDetails = createSelector(
  [
    getRestaurantName,
    getRestaurantHours,
    getRestaurantMaxAdvanceNoticeDays,
    getRestaurantMinAdvanceNoticeTime,
    getDecimalSeparator,
    getDecimalPoints,
    getDiningOptions,
    isTipEnabled,
    getBraintreeSandBoxToken,
    isPayPalEnabled,
    isOnCheckOutDisplayRestaurantInfo,
  ],
  (
    name,
    hoursOfOperation,
    maxAdvanceNoticeDays,
    minAdvanceNoticeTime,
    decimalSeparator,
    decimalPoints,
    diningOptions,
    isTipEnabled,
    paypalSandboxToken,
    isPayPalEnabled,
    isOnCheckOutDisplayRestaurantInfo
  ) => ({
    name,
    hoursOfOperation,
    maxAdvanceNoticeDays,
    minAdvanceNoticeTime,
    decimalSeparator,
    decimalPoints,
    diningOptions,
    isTipEnabled,
    paypalSandboxToken,
    isPayPalEnabled,
    isOnCheckOutDisplayRestaurantInfo,
  })
);

export const isDataNameFilterForDining = state =>
  get(state, 'dashboard.checkoutDiningChanged', false);
export const getRestaurantId = state =>
  get(state, 'dashboard.locationDetails.selectedLocationAddressId', '');
export const getRestaurantAddress = state =>
  get(state, 'dashboard.locationDetails.selectedLocationAddress', '');
export const getRestaurantDeliveryTime = state =>
  get(state, 'dashboard.locationDetails.deliveryTime', '');
export const getRestaurantDeliveryFees = state =>
  get(state, 'dashboard.locationDetails.delivery_fees', 0);
export const getRestaurantDistance = state =>
  get(state, 'dashboard.locationDetails.distance', 0);
export const getSelectedRestaurantName = state =>
  get(state, 'dashboard.locationDetails.restuarantName', '');
// Export Reducer
export const restaurantHasSignleLocation = state =>
  get(state, 'dashboard.locationDetails.restaurantHasSignleLocation', false);
export const getSelectedRestaurantLocationDetails = state =>
  get(state, 'dashboard.locationDetails', {});
export const getDeliveryDetails = state =>
  get(state, 'dashboard.deliveryDetails', {});
export const getPreviousModeOfOrder = state =>
  get(state, 'dashboard.previousModeOfOrder', {});
export const getUserLocation = state =>
  get(state, 'dashboard.userLocation', false);
export const getUserSelectedLocation = state =>
  get(state, 'dashboard.userSelectedLocation', '');
export const getUserLocationSet = state =>
  get(state, 'dashboard.isUserLocationSet', false);
export const isPaymentUponRecieptOnly = state => {
  const paymentOptions = get(
    state,
    'dashboard.merchantDetails.ltg_payment_option_2',
    {}
  );
  return (
    paymentOptions['payment_upon_receipt_only'] === true ||
    paymentOptions['prepay_and_payment_upon_receipt'] === true
  );
};
export const isPrepayOnly = state => {
  const paymentOptions = get(
    state,
    'dashboard.merchantDetails.ltg_payment_option_2',
    {}
  );
  return (
    paymentOptions['prepay_only'] === true ||
    paymentOptions['prepay_and_payment_upon_receipt'] === true
  );
};
export const isNotValidPaymentOptions = state => {
  const isPrepayOnlyStatus = isPrepayOnly(state);
  const isPaymentUponRecieptOnlyStatus = isPaymentUponRecieptOnly(state);
  const isPayPalEnabledStatus = isPayPalEnabled(state);
  return (
    (!isPaymentUponRecieptOnlyStatus &&
      isPrepayOnlyStatus &&
      !isPayPalEnabledStatus) ||
    (isPaymentUponRecieptOnlyStatus && !isPayPalEnabledStatus)
  );
};

export default DashboardReducer;



// WEBPACK FOOTER //
// ./src/views/dashboard/reducer.js